import React from 'react';

import { bemBlock } from '../../../modules/bem';
import { LayoutRow } from '../../layout-row/LayoutRow';

import { ItemOwnProps } from './item-props';

import './ActionsMenuSlotItem.less';

const block = bemBlock('n-actions-menu-slot-item');

export const ActionsMenuSlotItem = React.forwardRef<
  React.ElementRef<'div'>,
  React.ComponentProps<'div'> & Omit<ItemOwnProps, 'trailingElement' | 'leadingIcon'>
>(function ActionsMenuSlotItem(
  { className, children, active, destructive, onKeyDown, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={block({
        extra: className,
        modifiers: { active, destructive },
      })}
      {...props}
    >
      <LayoutRow width="100%" spacedChildren="sm" alignItems="center">
        {children}
      </LayoutRow>
    </div>
  );
});
